import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import { LogIn, CheckCircle2, AlertTriangle, LogOut } from 'lucide-react'; // <--- ADD LogOut
import api from '../api';

const PublicKiosk = () => {
    const { siteId } = useParams(); 
    const [step, setStep] = useState(1);
    const [pin, setPin] = useState('');
    const [workerName, setWorkerName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [error, setError] = useState('');
    
    // 🔥 NEW: Track if they signed IN or OUT
    const [lastAction, setLastAction] = useState(''); 
    
    const sigPad = useRef({});

    const handlePinSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const res = await api.post('attendance/verify_pin/', { pin });
            setWorkerName(res.data.name);
            setCompanyName(res.data.company);
            setStep(2);
        } catch (err) {
            setError("Invalid PIN. Please try again.");
            setPin('');
        }
    };

    const handleSignOn = async () => {
        if (sigPad.current.isEmpty()) return alert("Please sign first");
        const signatureData = sigPad.current.toDataURL();

        try {
            const res = await api.post('attendance/sign_on/', { 
                pin, 
                signature: signatureData,
                site_id: siteId 
            });
            
            // 🔥 CAPTURE ACTION (IN/OUT)
            setLastAction(res.data.action); 
            setStep(3);
            
            setTimeout(() => {
                setStep(1);
                setPin('');
                setWorkerName('');
                setLastAction(''); // Reset
            }, 3000);
        } catch (err) {
            alert("Error signing on. " + (err.response?.data?.error || ""));
        }
    };

    return (
        <div style={{minHeight:'100vh', background:'#0f172a', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontFamily:'sans-serif'}}>
            <div style={{width:'100%', maxWidth:'400px', padding:'20px'}}>
                
                {/* HEADER */}
                <div style={{textAlign:'center', marginBottom:'40px'}}>
                    <h1 style={{margin:0, fontSize:'1.8rem'}}>Site<span style={{color:'#3b82f6'}}>ACT</span> Kiosk</h1>
                    <p style={{color:'#94a3b8'}}>Site Access Register</p>
                </div>

                {/* STEP 1: PIN */}
                {step === 1 && (
                    <div className="card" style={{background:'#1e293b', padding:'30px', borderRadius:'12px', border:'1px solid #334155', textAlign:'center'}}>
                        <h2 style={{marginTop:0}}>Enter PIN</h2>
                        <form onSubmit={handlePinSubmit}>
                            <input 
                                type="tel" 
                                maxLength="6" 
                                value={pin} 
                                onChange={e => setPin(e.target.value)} 
                                style={{
                                    width:'100%', height:'60px', fontSize:'2rem', textAlign:'center', letterSpacing:'5px',
                                    background:'#0f172a', border:'1px solid #334155', color:'white', borderRadius:'8px', marginBottom:'20px'
                                }} 
                                autoFocus
                            />
                            {error && <div style={{color:'#ef4444', marginBottom:'15px', display:'flex', alignItems:'center', justifyContent:'center', gap:'5px'}}><AlertTriangle size={16}/> {error}</div>}
                            <button type="submit" style={{width:'100%', padding:'15px', background:'#3b82f6', color:'white', border:'none', borderRadius:'8px', fontSize:'1.1rem', fontWeight:'bold', cursor:'pointer'}}>Next</button>
                        </form>
                    </div>
                )}

                {/* STEP 2: SIGN */}
                {step === 2 && (
                    <div className="card" style={{background:'#1e293b', padding:'30px', borderRadius:'12px', border:'1px solid #334155'}}>
                        <div style={{textAlign:'center', marginBottom:'20px'}}>
                            <h2 style={{margin:0, color:'#3b82f6'}}>{workerName}</h2>
                            <p style={{margin:0, color:'#94a3b8'}}>{companyName}</p>
                        </div>
                        <div style={{background:'white', borderRadius:'8px', marginBottom:'20px', overflow:'hidden'}}>
                            <SignatureCanvas ref={sigPad} penColor="black" canvasProps={{width: 340, height: 160, className: 'sigCanvas'}} />
                        </div>
                        <p style={{fontSize:'0.8rem', color:'#94a3b8', textAlign:'center', marginBottom:'20px'}}>I verify that I am fit for work and have the correct PPE.</p>
                        <div style={{display:'flex', gap:'10px'}}>
                            <button onClick={() => setStep(1)} style={{flex:1, padding:'12px', background:'transparent', border:'1px solid #334155', color:'#94a3b8', borderRadius:'6px', cursor:'pointer'}}>Cancel</button>
                            <button onClick={handleSignOn} style={{flex:1, padding:'12px', background:'#10b981', border:'none', color:'white', borderRadius:'6px', fontWeight:'bold', cursor:'pointer'}}>Confirm</button>
                        </div>
                    </div>
                )}

                {/* STEP 3: SUCCESS (DYNAMIC) */}
                {step === 3 && (
                    <div style={{textAlign:'center', animation:'fadeIn 0.5s'}}>
                        {lastAction === 'IN' ? (
                            /* --- SIGN IN SUCCESS --- */
                            <div style={{background: 'rgba(16, 185, 129, 0.1)', padding:'30px', borderRadius:'12px', border:'2px solid #10b981'}}>
                                <CheckCircle2 size={80} color="#10b981" style={{marginBottom:'20px'}} />
                                <h2 style={{margin:0, color:'white'}}>SIGNED IN</h2>
                                <p style={{color:'#94a3b8', marginTop:'10px'}}>Welcome to site.</p>
                                <div style={{marginTop:'15px', color:'#10b981', fontWeight:'bold'}}>
                                    {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                                </div>
                            </div>
                        ) : (
                            /* --- SIGN OUT SUCCESS --- */
                            <div style={{background: 'rgba(250, 204, 21, 0.1)', padding:'30px', borderRadius:'12px', border:'2px solid #facc15'}}>
                                <LogOut size={80} color="#facc15" style={{marginBottom:'20px'}} />
                                <h2 style={{margin:0, color:'white'}}>SIGNED OUT</h2>
                                <p style={{color:'#94a3b8', marginTop:'10px'}}>Have a safe journey.</p>
                                <div style={{marginTop:'15px', color:'#facc15', fontWeight:'bold'}}>
                                    {new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PublicKiosk;